import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                 from '../../app-lite/shared/shared.module';
import { TableModule }                  from '../table/table.module';
import { VendorActionsComponent }       from './vendor.actions.component';
import { VendorActivityLogsComponent }  from './vendor.activity-logs.component';
import { VendorQuickAddComponent }      from './vendor.quick-add.component';
import { VendorsComponent }             from './vendors.component';
import { VendorSearchControlComponent } from './vendor.search-control.component';
import { VendorSearchService }          from './vendor.search.service';
import { VendorsService }               from './vendors.service';
import { VendorsStates }                from './vendors.states';

@NgModule({
  declarations: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorQuickAddComponent,
    VendorsComponent,
    VendorSearchControlComponent
  ],
  entryComponents: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorQuickAddComponent,
    VendorsComponent,
    VendorSearchControlComponent
  ],
  exports: [
    VendorsComponent,
    VendorSearchControlComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: VendorsStates })
  ],
  providers: [
    VendorSearchService,
    VendorsService
  ]
})
export class VendorsModule {}
